module.exports = __webpack_public_path__ + "static/media/ring.4f7ffc5e.mp3";